/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

/**
 * Entry point for csite_modules build
 */

const AudioVideoPlayers = require("./modules/AudioVideoPlayers");
const ContactForm = require("./modules/ContactForm");
const PageGalleries = require("./modules/PageGalleries");
const LoopPagination = require("./modules/LoopPagination");
const Newsfeed = require("./modules/Newsfeed");
const Maps = require("./modules/Maps");
const Newsletter = require("./modules/Newsletter/Newsletter");
const Containers = require("./modules/Containers");
const Pictures = require("./modules/Pictures");
const Utils = require("./Utils");
const Polyfill = require("./Polyfill");
const FrontPageSocket = require("./modules/FrontPageSessionManager");
// Pre-compiled by `tsc` into dist/ (see package.json's build scripts and tsconfig.json) - the
// Wizard tree is TypeScript, no longer handled live by webpack. wizardLoader.js itself is hand-
// written JS (not compiled) but is copied alongside its now-compiled siblings so its own
// relative imports ("./services/Bridge", "./Index") still resolve.
const WizardLoader = require("../dist/modules/Wizard/wizardLoader");
Polyfill();
function respectEmptyGridColumns() {
  let columns = document.querySelectorAll(".row > .col");
  for (let i = 0; i < columns.length; ++i) {
    let column = columns[i];
    if (column.children.length === 0) {
      column.classList.add("cms-column-empty");
    }
  }
}
function getPublicPath() {
  let webpackMetaData = document.querySelector("[data-webpack-metadata]");
  if (webpackMetaData !== null) {
    return webpackMetaData.getAttribute("data-cms-wp-public-path");
  }
  return "";
}
Utils.domReady(function () {
  __webpack_public_path__ = getPublicPath();
  AudioVideoPlayers.initPlayers();
  ContactForm.initContactForms();
  PageGalleries.initGalleries();
  LoopPagination.attachLoopPagination();
  Newsfeed.init();
  Maps.init();
  Containers.init();
  Newsletter.initSubscribeForms();
  Newsletter.initUnsubscribeForms();
  Newsletter.initConfirmAction();
  Pictures.initPicturesFunctionality();
  respectEmptyGridColumns();
  FrontPageSocket.StartFrontPageSessionManager();
  window.CMS4_SERVICES = {
    AudioVideoPlayers: AudioVideoPlayers,
    ContactForm: ContactForm,
    PageGalleries: PageGalleries,
    LoopPagination: LoopPagination,
    Newsfeed: Newsfeed,
    Maps: Maps,
    Newsletter: Newsletter,
    Containers: Containers,
    Pictures: Pictures,
    Utils: Utils
  };
  WizardLoader.default();

  // Send Escape key to parent for overlay deselection
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      window.parent.postMessage({
        type: 'iframe-escape'
      }, '*');
    }
  });
});
window._cmsGoogleMapsLoaded = function () {
  // empty function to prevent google maps from throwing an error
};